/**
 * This document contains all the helper functions for firebase.
 */

import { Auth } from "firebase/auth";
import { FIREBASE_MESSAGES } from "constants/constants";
import { Timestamp } from "firebase/firestore";

/**
 * Check if the user id exists (i.e. the user is signed in).
 */
export const userIdExists = (auth: Auth): boolean => {
    // Get the user from auth.
    const user = auth.currentUser
    // Grab user id.
    const uid = user?.uid
    // If the user is not signed in, return false.
    return !!uid
}

/**
 * Get the user's uid.
 */
export const getUserId = (auth: Auth): string => {
    // Get the user from auth.
    const user = auth.currentUser
    // Grab user id.
    const uid = user?.uid
    // If the user is not signed in, return an empty string.
    return uid || ''
}

/**
 * Decode the error message from firebase.
 */
export const decodeFirebaseError = (errorMessage: string): string => {
    const message = errorMessage
    const mapped = (FIREBASE_MESSAGES as { [key: string]: string })[message]
    if (mapped) return mapped
    for (const [code, key] of Object.entries(FIREBASE_MESSAGES)) {
        if (message.includes(code)) return key
    }
    return message
}

/**
 * Convert Timestamp to string.
 */
export const timestampToString = (timestamp: Timestamp): string => {
    return timestamp.toDate().toISOString()
}
